<script>
import resources from './resources'

export default {
  name: 'moving',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Lista
          |   - {{ guest.name }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.guest.list', params: {id: guest.id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', guest)") Excluir
      .body
        h6.m-b-15
          | {{ guest.name }}
          router-link(:to="{name: 'dweller.guest.list', params: {id: guest.id}}")
            span.badge.badge-success.float-right
              i.zmdi.zmdi-accounts-list
        .row
          .col-12
            span
              i.zmdi.zmdi-accounts-list &nbsp;
            span
              strong {{guest.persons.length}}

</template>
<style scoped>
  .online {
    color: #86BB71;
  }
  .offline {
    color: #E38968;
  }
  .online, .offline, .me {
      margin-right: 3px;
      font-size: 10px;
  }
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/guest/index/components/item.vue